import { Component, Input, OnInit, SimpleChanges } from "@angular/core";
import { Dictionary } from "src/app/store/models/common_types";

@Component({
  selector: "app-forecast-chart",
  templateUrl: "./forecast-chart.component.html",
  styleUrls: ["./forecast-chart.component.scss"],
})
export class ForecastChartComponent implements OnInit {
  @Input() ticker;
  chartType: string;
  chartDataToUse: Dictionary<any>;
  isDataLoaded = false;
  constructor() {
    this.chartType = "forecast-chart";
    this.ticker = "";
  }

  ngOnInit() {
    this.chartDataToUse = {
      ticker: this.ticker,
    };
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes.ticker.previousValue !== this.ticker) {
      this.chartDataToUse = {
        ticker: this.ticker,
      };
    }
  }
}
